<template>
  <v-container>
    <v-card>
      <v-card-text>
        <v-tabs vertical background-color="blue-grey lighten-5">
          <v-tab>Información General</v-tab>
          <v-tab>Información Importaciones</v-tab>
          <v-tab-item>
            <v-card>
              <v-card-text>
                <v-row>
                  <v-col>
                    <v-combobox
                      label="Operador"
                      :items="operadores"
                      v-model="operador"
                      item-text="operador"
                      item-value="operador"
                      return-object
                      clearable
                      append-icon="mdi-briefcase-account"
                    ></v-combobox>
                  </v-col>
                  <v-col>
                    <v-combobox
                      label="Depot"
                      :items="depots"
                      v-model="depot"
                      item-text="depot"
                      item-value="depot"
                      return-object
                      clearable
                      append-icon="mdi-map-marker-check"
                    ></v-combobox>
                  </v-col>
                  <v-col>
                    <v-text-field
                      label="Guía Agente"
                      v-model="datos.guia_agente"
                      clearable
                      append-icon="mdi-earth"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field
                      label="Fecha Arribo"
                      v-model="datos.fecha_arribo"
                      type="date"
                      clearable
                      append-icon="mdi-calendar"
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                      label="Fecha Liberación"
                      v-model="datos.fecha_liberacion"
                      type="date"
                      clearable
                      append-icon="mdi-calendar"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-radio-group v-model="datos.proceso" row label="Proceso">
                      <v-radio
                        v-for="proc in procesos"
                        :key="proc.value"
                        :label="proc.text"
                        :value="proc.value"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-combobox
                      label="Agente"
                      :items="agentes"
                      v-model="agente"
                      item-text="nombre"
                      item-value="id"
                      return-object
                      clearable
                      append-icon="mdi-account"
                    ></v-combobox>
                  </v-col>
                  <!--v-col>
                    <v-text-field
                    label="Tiempo Transito"
                    v-model="datos.tiempo_transito"
                    type="number"
                    readonly
                    append-icon="mdi-timer"
                    ></v-text-field>
                </v-col-->
                  <v-col>
                    <v-radio-group
                      v-model="datos.no_controlado"
                      row
                      label="No Controlado"
                    >
                      <v-radio
                        v-for="nc in noControlados"
                        :key="nc.value"
                        :label="nc.text"
                        :value="nc.value"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-textarea
                      label="Observación"
                      v-model="datos.observacion"
                      clearable
                      append-icon="mdi-pencil"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
                                <v-card>
                                    <v-card-text>
                                        <v-row dense>
                                            <v-col>
                                                <v-text-field
                                                label="Fecha Estimada Vuelo"
                                                v-model="datos.fecha_estimada_vuelo"
                                                type="date"
                                                clearable
                                                append-icon="mdi-calendar"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col>
                                                <v-text-field
                                                label="Fecha Declaracion"
                                                v-model="datos.fecha_declaracion"
                                                type="date"
                                                clearable
                                                append-icon="mdi-calendar"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row dense>
                                          <v-col>
                                            <v-text-field
                                                label="Novedad Vuelo"
                                                v-model="datos.novedad_vuelo"
                                                clearable
                                                append-icon="mdi-pencil"
                                                ></v-text-field>
                                          </v-col>
                                        </v-row>
                                        <v-row dense>
                                            <v-col>
                                                <v-text-field
                                                label="Tipo Aforo"
                                                v-model="datos.tipo_aforo"
                                                clearable
                                                append-icon="mdi-pencil-ruler"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col>
                                                <v-text-field
                                                label="Refrendo"
                                                v-model="datos.refrendo"
                                                clearable
                                                append-icon="mdi-file-document-edit"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row dense>
                                            <v-col>
                                                <v-text-field
                                                label="Valor Declarado"
                                                v-model="datos.valor_declarado"
                                                clearable
                                                append-icon="mdi-cash"
                                                type="number"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col>
                                                <v-text-field
                                                label="Peso Ingresado Aduana"
                                                v-model="datos.peso_ingresado_aduana"
                                                clearable
                                                append-icon="mdi-scale-balance"
                                                type="number"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col>
                                                <v-text-field
                                                label="Categoria"
                                                v-model="datos.categoria"
                                                clearable
                                                append-icon="mdi-file-compare"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row dense>
                                            <v-col>
                                                <v-text-field
                                                label="MRN"
                                                v-model="datos.mrn"
                                                clearable
                                                append-icon="mdi-file-document"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col>
                                                <v-text-field
                                                label="MSN"
                                                v-model="datos.msn"
                                                clearable
                                                append-icon="mdi-file-document"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row dense>
                                            <v-col>
                                                <v-text-field
                                                label="HSN"
                                                v-model="datos.hsn"
                                                clearable
                                                append-icon="mdi-file-document"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col>
                                                <v-text-field
                                                label="Estatus Aduana"
                                                v-model="datos.estatus_aduana"
                                                clearable
                                                append-icon="mdi-earth-box-plus"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row dense>
                                            <v-col>
                                                <v-textarea
                                                label="Causa Abandono"
                                                v-model="datos.causa_abandono"
                                                clearable
                                                append-icon="mdi-pencil"
                                                ></v-textarea>
                                            </v-col>
                                            <v-col>
                                                <v-textarea
                                                label="Novedad Inexpress"
                                                v-model="datos.novedad_inexpress"
                                                clearable
                                                append-icon="mdi-pencil"
                                                ></v-textarea>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-tab-item>
        </v-tabs>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn outlined color="primary darken-1" @click="updateDatos()"
          >Actualizar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import apicon from "../plugins/apicon";
export default {
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      compra: null,
      operadores: [{ operador: "AGENTE" }, { operador: "INEXPRESS" }],
      operador: null,
      depots: [{ depot: "GYE" }, { depot: "UIO" }, { depot: "ECO" }],
      depot: null,
      procesos: [
        { text: "Normal", value: true },
        { text: "Con Novedad", value: false },
      ],
      //proceso: null,
      noControlados: [
        { text: "Si", value: true },
        { text: "No", value: false },
      ],
      //noControlado: null,
      agentes: [],
      agente: null,
      datos: {
        operador: null,
        depot: null,
        guia_agente: null,
        fecha_arribo: null,
        fecha_liberacion: null,
        proceso: null,
        id_agente: null,
        //tiempo_transito: null,
        no_controlado: null,
        observacion: null,
        fecha_estimada_vuelo: null,
        novedad_vuelo: null,
        fecha_declaracion: null,
        dias_habiles_declaracion: null,
        dias_habiles_liberacion: null,
        tipo_aforo: null,
        refrendo: null,
        mrn: null,
        msn: null,
        hsn: null,
        valor_declarado: null,
        peso_ingresado_aduana: null,
        categoria: null,
        causa_abandono: null,
        estatus_aduana: null,
        novedad_inexpress: null,
      },
    };
  },
  watch: {
    operador: function (item) {
      if (item) {
        this.datos.operador = item.operador;
      }
    },
    depot: function (item) {
      if (item) {
        this.datos.depot = item.depot;
      }
    },
    agente: function (item) {
      if (item) {
        this.datos.id_agente = item.id;
      }else{
        this.datos.id_agente = null;
      }
    },
  },
  methods: {
    getAgentes: async function () {
      await apicon
        .getDataApi(apicon.getApiBaseUrl() + "agente")
        .then((result) => {
          this.agentes = result;
        });
    },
    updateDatos: async function () {
      await apicon
        .updateDataApi(
          apicon.getApiBaseUrl() + "compraslinea/" + this.id,
          this.datos
        )
        .then((result) => {
          this.$swal(result.message);
        });
    },
    popularDatos: async function () {
      if (this.id > 0) {
        await apicon
          .getDataApi(apicon.getApiBaseUrl() + "compraslinea/" + this.id)
          .then((result) => {
            this.compra = result;
            Object.keys(this.datos).forEach((key) => {
              this.datos[key] = result[key];
            });
            this.operador = this.operadores.find(
              (op) => op.operador === result.operador
            );
            this.depot = this.depots.find((dep) => dep.depot === result.depot);
            this.datos.proceso =
              result.proceso == null ? null : Boolean(result.proceso);
            this.agente = this.agentes.find(
              (age) => age.id === result.id_agente
            );
            this.datos.no_controlado =
              result.no_controlado == null
                ? null
                : Boolean(result.no_controlado);
          });
      }
    },
  },
  mounted: async function () {
    await apicon.setAuthHeaders();
    await this.getAgentes();
    await this.popularDatos();
  },
};
</script>
